import { OnInit, Component } from '@angular/core';
import { ReconApiService } from '../../services/recon-api.service';

@Component({
    selector: 'module',
    templateUrl: 'healthcheck.component.html'
})
export class HealthCheckComponent implements OnInit {
    constructor(private reconApi: ReconApiService) { }
    ngOnInit(): void {
    }
}



// WEBPACK FOOTER //
// ./src/app/components/healthcheck/healthcheck.component.ts